import { render } from "./ConfirmDlg.vue?vue&type=template&id=267f3cd6"
import script from "./ConfirmDlg.vue?vue&type=script&lang=module"
export * from "./ConfirmDlg.vue?vue&type=script&lang=module"

import exportComponent from "/Users/alexeysorokin/Desktop/hexp2/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__